module.exports = __webpack_public_path__ + "images/linkedin.svg";


//////////////////
// WEBPACK FOOTER
// ./images/linkedin.svg
// module id = 23
// module chunks = 1